import { Button } from "@msuite/ui/button";
import { AlertIcon, Icon, SuccessIcon } from "@msuite/ui/icons";
import { capitalize } from "@msuite/utils/strings";
import type { Enums, Nullable, UserIntegrationSafe } from "@msuite/utils/types";

/** Props Interface */
interface UserIntegrationCardProps {
	integrationType: Enums<"integrationType">;
	userIntegration?: Nullable<UserIntegrationSafe["userIntegration"]>;
}

export function UserIntegrationCard({
	integrationType,
	userIntegration,
}: UserIntegrationCardProps) {
	/** Render */
	return (
		<div className="h-stack gap-2">
			{userIntegration ? <SuccessIcon /> : <AlertIcon />}
			<p>{capitalize(integrationType)}</p>
			<div className="flex-1" />
			<Button
				variant="white"
				size="xxs"
				icon={<Icon name="Zap" />}
			>
				Connect
			</Button>
		</div>
	);
}
